<div *ngFor="let juniorCamp of camps" class="junior-camps-data">
  <lx-price-lists-portal-junior-camps-header
    [company]="company"
    [juniorCamp]="juniorCamp"
    [applicationForms]="applicationForms"
  ></lx-price-lists-portal-junior-camps-header>
  <lx-price-lists-portal-camps-course-table
    [company]="company"
    [currency]="juniorCamp?.juniorCampInfo?.currency"
    [packages]="juniorCamp?.packages"
    [courseNotes]="juniorCamp?.notes"
  ></lx-price-lists-portal-camps-course-table>
  <lx-price-lists-portal-camp-dates
    [company]="company"
    [currency]="juniorCamp?.juniorCampInfo?.currency"
    [endDatesFlag]="endDatesFlag"
    [juniorDatesNotes]="juniorCamp?.notes"
    [startDates]="juniorCamp.startDates"
  ></lx-price-lists-portal-camp-dates>
  <div [class.junior-camps-data__two-columns-container]="juniorCamp.premiumActivities.length">
    <lx-price-lists-portal-premium-activities
      [company]="company"
      [currency]="juniorCamp.juniorCampInfo?.currency"
      [premiumActivitiesNotes]="juniorCamp?.notes"
      [premiumActivities]="juniorCamp.premiumActivities"
    ></lx-price-lists-portal-premium-activities>
    <lx-price-lists-portal-camps-transfers-table
      [company]="company"
      [currency]="juniorCamp?.juniorCampInfo?.currency"
      [transferNotes]="juniorCamp?.notes"
      [transfers]="juniorCamp?.transfers"
    ></lx-price-lists-portal-camps-transfers-table>
  </div>
  <div [class.junior-camps-data__two-columns-container]="juniorCamp.privateLessons">
    <lx-price-lists-portal-general-fee-table
      [company]="company"
      [currency]="juniorCamp.juniorCampInfo?.currency"
      [generalFeesNotes]="juniorCamp?.notes"
      [generalFees]="juniorCamp.fees"
    ></lx-price-lists-portal-general-fee-table>
    <lx-price-lists-portal-junior-camps-private-lessons
      *ngIf="juniorCamp.privateLessons"
      [company]="company"
      [currency]="juniorCamp.juniorCampInfo?.currency"
      [privateLessonsNotes]="juniorCamp?.notes"
      [privateLessons]="juniorCamp.privateLessons"
    >
    </lx-price-lists-portal-junior-camps-private-lessons>
  </div>
  <lx-additional-info *ngIf="juniorCamp?.additionalInfo?.length > 0" [additionalInformation]="juniorCamp?.additionalInfo"></lx-additional-info>
</div>
